<template>
  <section v-if="!isOnline" class="network-status">
    <AnimatedText el="h1" class="network-status__copy">
      {{ $t('status.network.status') }}<br />
      {{ $t('status.network.checkConnection') }}
    </AnimatedText>
  </section>
</template>

<script>
import AnimatedText from '../AnimatedText';

export default {
  name: 'NetworkStatus',

  components: { AnimatedText },

  data() {
    return {
      isOnline: true,
    };
  },

  created() {
    this.watchNetworkStatus();
  },

  methods: {
    watchNetworkStatus() {
      // nice gimmick if user is offline we show up a notification
      window.addEventListener('offline', this.networkStatus);
      window.addEventListener('online', this.networkStatus);

      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('offline', this.networkStatus);
        window.removeEventListener('online', this.networkStatus);
      });
    },

    networkStatus({ type }) {
      if (type === 'online') {
        this.isOnline = true;
      } else if (type === 'offline') {
        this.isOnline = false;
      } else {
        // eslint-disable-next-line no-console
        console.log('[App]: onNetworkStatusChanged - error ', type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.network-status {
  width: 100%;
  height: 100%;
  background: $color-blue;
  position: absolute;
  z-index: 999;
}

.network-status__copy {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: $color-black;
}
</style>
